import React from 'react'
import { Layout } from 'antd'
import styles from './footer.module.less'

const MetisFooter = () => {
  return (
    <Layout.Footer className={styles.footer}>
      <div className={styles.help}>
        <span className={styles.service}>客服电话： </span>
        <span className={styles.servicePhone}>400-620-9008</span>
        <span className={styles.serviceTime}>(工作日9:00-18:00)</span>
      </div>
      <div className={styles.icp}>
        ICP号：
        <a href="//beian.miit.gov.cn" target="_blank" rel="noreferrer">沪B2-20090008-1</a>
        <span> \ Powered by © 2017</span>
      </div>
    </Layout.Footer>
  )
}

export { MetisFooter }
